import { CURRENT_DOCUMENT_TOPICS, REMOVE_DOCUMENT_TOPIC } from '../actions';

export default ( state = [], action ) => {
	switch ( action.type ) {
		case CURRENT_DOCUMENT_TOPICS:
			if ( action.payload === false ) {
				return [];
			}
			return ( state.includes( action.payload )
			       ) ? state : [ ...state, action.payload ];
			break;
		case REMOVE_DOCUMENT_TOPIC:
			let commIndex = state.indexOf( action.payload );
			let newState = [
				...state.slice( 0, commIndex ), ...state.slice( commIndex + 1 )
			];
			return [ ...newState ];
			break;
	}
	return state;
}